import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import { environment } from './../../environments/environment';
//import { Chiamata } from './chiamata.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AuthService } from './auth.service';
import { Device } from './../models/device.model';

@Injectable({
  providedIn: 'root'
})
export class SocketioService {
  socket: any;
  connessione = new Subject<boolean>();
  private eventiRegistrati: Set<string> = new Set();
  totemLog = new Subject<any>();
  pluginHealthCardUser = new Subject<any>();
  sportelloTotemLog = new Subject<any>();
  agendaTicketUpdate = new Subject<any>();
  codaChiamateUpdate = new Subject<any>();

  constructor(
    private authService: AuthService
  ) { }

  async setupSocketConnection() {
    const token = this.authService.getBearerToken();
    const tockenDevice = this.authService.getetDeviceToken();
    const extraHeaders: { [key: string]: string } = {};

    if (token) {
      extraHeaders['Authorization'] = `Bearer ${token}`;
    }
    if (tockenDevice) {
      extraHeaders['x-device-token'] = `${tockenDevice}`;
    }
    return new Promise ((resolve, reject) => {
      this.socket = io('/', {
        extraHeaders: extraHeaders
      }).on('connect', () => {
        resolve(true);
        console.log('socket connected');
        this.connessione.next(true);
      }).on('connect_error', (err) => {
        console.log('socket error');
        console.error(err);
        this.connessione.next(false);
        reject(err);
      }).on('disconnect', () => {
        console.log('socket disconnected');
        this.connessione.next(false);
      })
    });
  }

  updateToken(token: string) {
    if (this.socket && this.socket?.io?.opts?.extraHeaders?.Authorization) {
      const extraHeaders: { [key: string]: string } = {};
      extraHeaders['Authorization'] = `Bearer ${token}`;
      this.socket.io.opts.extraHeaders = extraHeaders;
      console.log('Updated socket token:', this.socket.io.opts.extraHeaders);
      this.socket.disconnect();
      this.socket.connect();
    }
  }

  onTotemLog() {
    this.socket.on(`totem:log`, (data: any) => {
      console.log('LOG TOTEM = ', data);
      this.totemLog.next(data);
    });
  }

  onPluginHealthCardUser() {
    this.socket.on('plugin:healthcard:user', (data: any) => {
      console.log('PLUGIN HEALTH CARD USER = ', data);
      this.pluginHealthCardUser.next(data);
    });
  }

  onSportelloTotemLog() {
    this.socket.on('totem:log', (data: any) => {
      this.sportelloTotemLog.next(data);
    });
  }

  onAgendaTicketUpdate() {
    this.socket.on('agenda:ticket:update', (data: any) => {
      console.log('NOTIFICA AGENDA TICKET UPDATE =' , data);
      this.agendaTicketUpdate.next(data);
    });
  }

  onCodaChiamateUpdate(device: Device) {
    const eventName = `view:${device.view_id}:queue:updated`;
    console.log('Evento già registrato:', this.eventiRegistrati.has(eventName));
    if (!this.eventiRegistrati.has(eventName)) { // Verifico se l'evento è già registrato
      this.eventiRegistrati.add(eventName); // Aggiungo l'evento agli eventi registrati
      this.socket.on(eventName, (data: any) => {
        console.log('NOTIFICA CODA =' , data);
        this.codaChiamateUpdate.next(data);
      });
    }  
  }


  /* chimamtaInserita(chiamata: Chiamata) {
    this.socket.emit('chiamataInserita', chiamata);
  } */

  /* chiamataRicevuta() {
    this.socket.on('chiamataRicevuta', (data: Chiamata) => {
      // console.log('NOTIFICA RICEVUTA SERVICE', data);
      this.chiamata.next(data);
    });
  } */

  /* cambioStatoChiamata(chiamata: Chiamata) {
    this.socket.emit('cambioStato', chiamata);
  }
  notificaCambioStato() {
    this.socket.on('notificaCambioStato', (data: Chiamata) => {
      // console.log('NOTIFICA CAMBIO STATO', data);
      this.chiamataNuovoStato.next(data);
    });
  } */

  /* chiamataEliminata(chiamata: Chiamata) {
    this.socket.emit('chiamataEliminata', chiamata);
  }
  notificaChiamataEliminata() {
    this.socket.on('notificaChiamataEliminata', (data: Chiamata) => {
      // console.log('NOTIFICA CHIAMATA ELIMINATA', data);
      this.chiamataCanc.next(data);
    });
  } */

  refreshMonitor() {
    this.socket.emit('refreshMonitor');
  }
  
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}
